import { createFileRoute } from '@tanstack/react-router';

import { Seo } from '@/common/components/seo';
import { FeedsList } from '@/feeds/pages/feeds-list';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/feeds/')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: FeedsRoute
});

function FeedsRoute() {
  return (
    <>
      <Seo title="Feeds" />
      <FeedsList />
    </>
  );
}
